define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var RoleGroupModel = /** @class */ (function () {
        function RoleGroupModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.Description = ko.observable();
            this.PermissionGroups = ko.observableArray();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, RoleGroupModel.Mapping, self);
            }
        }
        RoleGroupModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new RoleGroupModel(options.data);
            }
        };
        return RoleGroupModel;
    }());
    return RoleGroupModel;
});
//# sourceMappingURL=RoleGroupModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/RoleGroupModel.js
// module id = 285
// module chunks = 2